import React from 'react';
import productData from './productData';
import Card from '@/components/ui/cards/Card';
import CardHeader from '@/components/ui/cards/CardHeader';
import CardBody from '@/components/ui/cards/CardBody';
import { getFileUrl } from '@/services/CommonService';
import CurrencyCodeAdd from '@/components/common/CurrencyCodeAdd';

const MostPopularItemsComponent = ({ dataSource }) => {
    return (
        <Card>
            <CardHeader isBorder={true}>
                <h3 className="db-card-title">Most Popular Items</h3>
            </CardHeader>
            <CardBody>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-[18px]">
                    {dataSource?.popular_items &&
                        dataSource?.popular_items.length > 0 &&
                        dataSource?.popular_items.map((data, index) => (
                            <li key={index} className="w-full flex rounded-xl border border-[#D9DBE9]">
                                <img className="flex w-20 h-20 object-cover rounded-l-[11px]" src={getFileUrl(data?.file_name, 'product')} alt="product" />
                                <div className="py-2 px-3 flex flex-col justify-between overflow-hidden">
                                    <h4 className="text-sm overflow-hidden whitespace-nowrap text-ellipsis font-medium capitalize">{data?.name}</h4>
                                    <h5 className="text-xs font-medium capitalize text-[#008BBA]">{data.item_category?.name}</h5>
                                    <h6 className="text-sm font-bold">
                                        <CurrencyCodeAdd price={data?.price} />
                                    </h6>
                                </div>
                            </li>
                        ))}
                </ul>
            </CardBody>
        </Card>
    );
};

export default MostPopularItemsComponent;
